import React from 'react';

import { colors } from 'helpers/colors';

function SvgUpRightArrow({ size = 30, color = colors.gray[700] }) {
  return (
    <svg width={size} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.75 7.95V0.75M8.75 0.75H1.55M8.75 0.75L0.75 8.75" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default SvgUpRightArrow;
